let rootApp = null;

export function initAuthService(app) {
    rootApp = app;
}

export function getCurrentUser() {
    return rootApp?.user ?? null;
}

export function getUserPromise() {
    return rootApp?.userPromise ?? Promise.resolve(getCurrentUser());
}

export function hasPermission(permission) {
    if (!permission) {
        return true;
    }

    return getCurrentUser()?.permissions?.includes(permission) ?? false;
}

export function getProjectSetting(key) {
    return getCurrentUser()?.project_settings?.find(item => item.key === key)?.value;
}

export function hasRole(user, name, requireAll = false) {
    if (!user?.roles) {
        return false;
    }

    if (Array.isArray(name)) {
        if (name.length === 0) {
            return true;
        }

        for (const roleName of name) {
            const userHasRole = hasRole(user, roleName);

            if (userHasRole && !requireAll) {
                return true;
            }

            if (!userHasRole && requireAll) {
                return false;
            }
        }

        return requireAll;
    }

    return user.roles.some(role => {
        if (typeof role === 'string') {
            return role === name;
        }

        return role.name === name;
    });
}

export default {
    initAuthService,
    getCurrentUser,
    getUserPromise,
    hasPermission,
    getProjectSetting,
    hasRole,
};
